"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _require = require('./consts'),
  defaultReservedParamNames = _require.reservedParamNames,
  dataFixerParamNames = _require.dataFixerParamNames,
  mandatoryPageModuleRequestParams = _require.mandatoryPageModuleRequestParams,
  mandatorySiteModuleRequestParams = _require.mandatorySiteModuleRequestParams;
var _require2 = require('./errors'),
  ReservedParameterError = _require2.ReservedParameterError;
var _require3 = require('./kendash'),
  notEmpty = _require3.notEmpty;
var paramNames = function paramNames(arr) {
  return arr ? Object.keys(arr) : [];
};
var makeModuleValidator = require('./moduleValidtor');
var makeVersionValidator = require('./versionValidator');
var makePageValidator = require('./pageValidtor');
var makeRevisionValidator = require('./revisionValidtor');
var makeIdValidator = require('./idValidtor');
var makeContentTypeValidator = require('./contentTypeValidator');
var makeCommonConfigValidator = require('./commonConfigValidator');
var makeMandatoryParamsValidator = require('./mandatoryParamsValidator');
var pageMandatoryParamsValidator = makeMandatoryParamsValidator(mandatoryPageModuleRequestParams);
var siteMandatoryParamsValidator = makeMandatoryParamsValidator(mandatorySiteModuleRequestParams);

// todo refactor: validationCheckMessage should get the params and build the whole message (extract message building to a collaborator)
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$additionalReserv = _ref.additionalReservedParams,
    additionalReservedParams = _ref$additionalReserv === void 0 ? [] : _ref$additionalReserv,
    _ref$moduleList = _ref.moduleList,
    moduleList = _ref$moduleList === void 0 ? [] : _ref$moduleList;
  var versionValidator = makeVersionValidator();
  var siteRevisionValidator = makeRevisionValidator();
  var pageValidator = makePageValidator();
  var siteIdValidator = makeIdValidator();
  var contentTypeValidator = makeContentTypeValidator();
  var moduleValidator = makeModuleValidator(moduleList);
  var commonConfigValidator = makeCommonConfigValidator(siteRevisionValidator, siteIdValidator);

  /**
   * validate that custom module params must not contain reserved param names
   */
  var customParamsValidation = {
    predicate: function predicate(param) {
      return [].concat(_toConsumableArray(additionalReservedParams), _toConsumableArray(defaultReservedParamNames)).includes(param);
    },
    validationCheckMessage: 'reserved param'
  };

  /**
   * validate that data fixer params must only contain allowed data fixer param names
   */
  var dataFixerParamsValidation = {
    predicate: function predicate(param) {
      return !dataFixerParamNames.includes(param);
    },
    validationCheckMessage: 'not data fixer param'
  };
  var validateReservedParams = function validateReservedParams(params, validation) {
    var invalidParams = paramNames(params).filter(validation.predicate);
    if (notEmpty(invalidParams)) {
      throw new ReservedParameterError(validation.validationCheckMessage, invalidParams);
    }
  };
  return {
    validateCustomParams: function validateCustomParams(params) {
      return validateReservedParams(params, customParamsValidation);
    },
    validateDataFixerParams: function validateDataFixerParams(params) {
      return validateReservedParams(params, dataFixerParamsValidation);
    },
    validateMandatoryPageModuleParams: function validateMandatoryPageModuleParams(params) {
      return pageMandatoryParamsValidator.validate(params);
    },
    validateMandatorySiteModuleParams: function validateMandatorySiteModuleParams(params) {
      return siteMandatoryParamsValidator.validate(params);
    },
    validateModule: function validateModule(module) {
      return moduleValidator.validate(module);
    },
    validateVersion: function validateVersion(version) {
      return versionValidator.validate(version);
    },
    validateSiteId: function validateSiteId(id) {
      return siteIdValidator.validate(id);
    },
    validateSiteRevision: function validateSiteRevision(revision) {
      return siteRevisionValidator.validate(revision);
    },
    validatePage: function validatePage(page) {
      return pageValidator.validate(page);
    },
    validateContentType: function validateContentType(contentType) {
      return contentTypeValidator.validate(contentType);
    },
    validateCommonConfig: function validateCommonConfig(commonConfig) {
      return commonConfigValidator.validate(commonConfig);
    }
  };
};
//# sourceMappingURL=validator.js.map